/**
 * Easy read/write interface to <meta> tags.
 */
class Meta {
  static get(key) {
    return this.instance.get(key);
  }

  static set(key, value) {
    return this.instance.set(key, value);
  }

  static get instance() {
    return this._instance || (this._instance = new this(document.head));
  }

  constructor(head) {
    this.head = head;
  }

  get(key) {
    const element = this.#retrieve(key);
    if (!element) {
      return undefined;
    }
    return element.getAttribute('content');
  }

  set(key, value) {
    const element = this.#retrieve(key);
    if (!element) {
      throw new Error(`can't update value on <meta name="${key}">: no such element!`);
    }
    return element.setAttribute('content', value);
  }

  #retrieve(key) {
    return this.head.querySelector(`meta[name="${key}"]`);
  }
}

export default Meta;
